<template>
<div ref="main" @mouseover="closedHovered = true" @mouseleave="closedHovered = false" @click="handleOpen" :class="['column expandable is-paddingless ' + checkMaxHeight, open ? 'is-offset-0 is-12 ' : checkOffset + ' is-half-mobile is-one-third-fullhd is-one-third-tablet']">
  <!-- <div @click="handleOpen()" :class="['column expandable is-paddingless ' + checkMaxHeight, open ? 'is-offset-0 is-12 ' : checkOffset + ' is-half-mobile is-one-third-fullhd is-half-tablet']"> -->
  <!-- {{ this.src }} {{isTransitioning}} -->
  <slot></slot>
  <div v-if="border" class="lookbook-bg-border" :style="'border-image: url(' + getBorder() + ') ' + borderSlice + ' ' + borderSlice + ' repeat; ' + [borderHeight == '' ? '' : 'height: ' + borderHeight +'vh']">

  </div>
  <div ref="lookbookEl" class="lookbook-bg-container" :style="'background-color: #' + this.color">
    <div class="lookbook-bg-container" :style="bgCenter">
      <div :class="['lookbook-bg-container scale-ani', !open && closedHovered && !isTransitioning ? 'scale-up'  : '']" :style="bgRight">
        <div class="lookbook-bg-container" :style="bgLeft">
          <lazyImage class="proportions-helper" :lazySrc="placeholder" :width="1134" :height="1605"></lazyImage>
          <transition name="router-transition" mode="out-in">
            <div ref="info" :class="['lookbook-info', bgOffset < 50 ? ' right' : '']" v-show="open">

              <div class="test">

                <p>{{title}}</p>
                <p>{{price}}</p>
                <a :href="link" target="_blank" class="styled-button">Buy Now</a>
                <p class="lookbook-hasBackside" v-if="hasBackside && link2 == ''" @mouseover="hovered = true" @mouseleave="hovered = false">View Backside</p>


                <p style="padding-top: 4rem" v-if="link2 != ''">{{title2}}</p>
                <p v-if="link2 != ''">{{price2}}</p>
                <a v-if="link2 != ''" :href="link2" target="_blank" class="styled-button">Buy Now</a>
                <p class="lookbook-hasBackside" v-if="hasBackside && link2 != ''" @mouseover="hovered = true" @mouseleave="hovered = false">View Backside</p>
              </div>
            </div>
          </transition>


        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import lazyImage from '@/components/layout/_lazyImage.vue';

export default {
  name: 'columnWithOffsetBg',
  data() {
    return {
      open: false,
      hovered: false,
      preloaded: false,
      closedHovered: false,
      isTransitioning: false
    }
  },
  components: {
    lazyImage
  },
  computed: {

    bgLeft() {
      return 'background:  url(' + this.source('left') + ') left bottom'
    },
    bgRight() {
      return 'background: url(' + this.source('right') + ') right bottom'
    },
    bgCenter() {
      let centerSide = this.hasBackside && this.hovered ? 'center_back' : 'center';
      return 'background:  url(' + this.source(centerSide) + ') ' + this.bgOffset + '% bottom'
    },

    checkOffset() {
      let isMobile = this.$root.isMobile;
      let offset = isMobile ? Math.round(this.offset / 2 + 1) : this.offset
      return this.offset == '0' ? '' : ' is-offset-' + offset
    },
    checkMargin() {
      return this.margin == '0' ? '' : 'margin-top: ' + this.margin + '%;'
    },
    checkMaxHeight() {
      return this.maxHeight == true ? ' max-height' : ''
    },
    checkWidth() {
      let isMobile = this.$root.isMobile;
      let defaultWidth = 4;
      return isMobile ? ' is-half-mobile' : ' is-one-third-fullhd'
    },
    placeholder() {
      return require('@/assets/images/lblayers/proportions.png')
    },
  },
  mounted() {
    this.$refs.main.addEventListener("transitionend", this.onTransitionStart);
    this.$refs.main.addEventListener("transitionstart", this.onTransitionEnd);
  },
  beforeDestroy() {
    this.$refs.main.removeEventListener("transitionend", this.onTransitionStart);
    this.$refs.main.removeEventListener("transitionstart", this.onTransitionEnd);
  },
  methods: {
    onTransitionEnd(e) {
      if (e.propertyName == 'width') {
        this.isTransitioning = true
      }
    },
    onTransitionStart(e) {
      if (e.propertyName == 'width') {
        this.isTransitioning = false
      }
    },
    preloadImages(srcs, imgs) {
      var img;
      var self = this;
      var remaining = srcs.length;
      for (var i = 0; i < srcs.length; i++) {
        img = new Image();
        img.onload = function() {
          --remaining;
          if (remaining <= 0) {
            // callback();
          }
        };
        img.src = srcs[i];
        self.preloaded = true;
        //  imgs.push(img);
      }
    },
    handleOpen(e) {
      if (e.target.tagName == 'A' || e.target.tagName == 'P') {
        return
      }
      if (!this.preloaded && this.hasBackside) {
        this.preloadImages(['http://localhost:8080' + this.source('center_back')])
      }
      this.open = !this.open
      if (this.open && !this.$root.isMobile) {
        this.$refs.lookbookEl.scrollIntoView({
          block: "start",
          behavior: "smooth"
        });
      }
    },
    source(align) {
      return require('@/assets/images/lblayers/lookbook_' + this.src + '_' + align + '.png')
    },
    getBorder() {
      return require('@/assets/images/lblayers/lookbook_' + this.src + '_' + 'border.png')
    },

  },

  props: {
    width: {
      type: String,
      default: 'auto'
    },
    maxHeight: {
      type: Boolean,
      default: true
    },
    hasBackside: {
      type: Boolean,
      default: false
    },
    offset: {
      type: String,
      default: '0'
    },
    bgOffset: {
      type: String,
      default: '80'
    },
    margin: {
      type: String,
      default: '0'
    },
    align: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: false
    },
    borderSlice: {
      type: String,
      default: '199'
    },
    borderHeight: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    title2: {
      type: String,
      default: ''
    },
    price2: {
      type: String,
      default: ''
    },

    link2: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
.lookbook-bg-border {
    height: calc(100% - 4vw /2);
    width: 100%;
    border: 8vw solid transparent;
    position: absolute;
    z-index: 1;
    pointer-events: none;
}

.align-center {
    align-self: center;
}

.align-bottom {
    align-self: flex-end;
}
.expandable {
    transition: width 1s cubic-bezier(0.645, 0.045, 0.355, 1), margin 1s cubic-bezier(0.645, 0.045, 0.355, 1);
    backface-visibility: hidden;
    transform: translateZ(0);
    overflow: hidden;
    will-change: margin, width;
    cursor: pointer;
    img {
        transform: translateZ(0);
        will-change: max-height;
    }
}
.proportions-helper {
    opacity: 0;
    pointer-events: none;
}
.scale-ani {
    transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    &.scale-up {
        transform: scale(1.05);
    }
}
.lookbook-info {
    width: 50vw;
    position: absolute;
    height: 100%;
    top: 0;
    .lookbook-hasBackside {
        font-size: 1rem;
    }
    div {
        text-align: center;
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .buy-now {
            border-radius: 2rem;
            margin: 1rem;

            filter: drop-shadow(0px 0px 3px red) drop-shadow(0px 0px 7px black);
            padding: 0 1em 5px;
            cursor: pointer;
            border: 2px $red solid;
            color: $red;
        }
    }
    &.right {
        // float: right;
        right: 0;
    }
}
.max-height {
    position: relative;

    img {
        max-height: 100vh;

    }
}

@media screen and (max-width: 600px) {

    .lookbook-info {
        div {
            text-align: left;
            position: absolute;
            bottom: 0;
            left: 0;
            transform: none;
            top: auto;
            .buy-now {
                background: black;
            }
            p:not(.buy-now) {
                margin: 0 2rem;
            }
        }
        &.right {
            float: right;
            right: 0;
        }
    }
}
</style>
